import { useSelector } from "react-redux"
import { queryClient as qc } from 'keys'
import { getMethodsFetch } from "store/middlewares/affiliation.crud"
import { useQuery } from "@tanstack/react-query"
import { useMemo } from "react"
import { createAffiliationHooks } from ".."

const useFormFields = (props) => {
    const { schools } = props
    const { groups } = useSelector(state => state.affiliation)
    const formValues = useSelector(state => state.form.createAffliation?.values)
    const affiliationField = createAffiliationHooks.useAffiliationField(schools)

    const methodOptions = useQuery({
        queryKey: [qc.methods],
        queryFn: async () => {
            const { data } = await getMethodsFetch()
            return data
        },
    })

    const fields = useMemo(
        () => [
            {
                name: 'group',
                component: "autoComplete",
                placeholder: "קבוצה",
                options: groups,
                className: "form-field",
                mandatory: true
            },
            {
                ...affiliationField,
                className: "form-field",
                subText: formValues?.school ? `קוד מוסד ${formValues.school?.institution_code}` : null,
            },
            {
                name: 'method',
                component: "autoComplete",
                placeholder: "שיטה",
                className: "form-field",
                options: methodOptions?.data,
                mandatory: true
            },

        ], [schools, formValues]
    )

    const contactFields = useMemo(
        () => [
            {
                name: 'contact_first_name',
                component: "input",
                placeholder: "שם פרטי איש קשר",
                className: "form-field"
            },
            {
                name: 'contact_last_name',
                component: "input",
                placeholder: "שם משפחה איש קשר",
                className: "form-field"
            },
            {
                name: 'contact_phone',
                component: "input",
                placeholder: "טלפון איש קשר",
                className: "form-field"
            },
            {
                name: 'contact_email',
                component: "input",
                placeholder: "מייל איש קשר",
                className: "form-field"
            }
        ], [formValues]
    )

    const principalFields = useMemo(
        () => [
            {
                name: 'principal_first_name',
                component: "input",
                placeholder: "שם מנהל",
                className: "form-field"
            },
            {
                name: 'principal_last_name',
                component: "input",
                placeholder: "שם משפחה מנהל",
                className: "form-field"
            },
            {
                name: 'principal_phone',
                component: "input",
                placeholder: "טלפון מנהל",
                className: "form-field"
            },
            {
                name: 'principal_email',
                component: "input",
                placeholder: "מייל מנהל",
                className: "form-field"
            }
        ], [formValues]
    )

    return { fields, contactFields, principalFields }
}

export default useFormFields